// 缓存配额数据，避免重复解析
let quotaCache = null;
let cacheTimestamp = 0;
const CACHE_DURATION = 5 * 60 * 1000; // 5分钟缓存

// 默认的配额数据
const DEFAULT_QUOTA_LIST = [
  {
    "id": 6,
    "system": "achievement-assistant",
    "name": "rencaixiangqing",
    "label": "人才详情",
    "path": "/scholar/detail",
    "quota": 1,
    "order": 0,
    "price": 0.01
  },
  {
    "id": 8,
    "system": "achievement-assistant",
    "name": "rencaibaogao",
    "label": "人才报告",
    "path": "/report/scholarReport",
    "quota": 1,
    "order": 2,
    "price": 0.01
  },
  {
    "id": 9,
    "system": "achievement-assistant",
    "name": "yinwenbaogao",
    "label": "引文报告",
    "path": "/report/citeReport",
    "quota": 1,
    "order": 3,
    "price": 0.01
  },
  {
    "id": 13,
    "system": "achievement-assistant",
    "name": "resultsAnalysis",
    "label": "成果分析",
    "path": "/api/analysis/create-task",
    "quota": 1,
    "order": 4,
    "price": 0.01
  },
  {
    "id": 14,
    "system": "achievement-assistant",
    "name": "requirementAnalysis",
    "label": "需求分析",
    "path": "/tech/disassembly_v3",
    "quota": 1,
    "order": 5,
    "price": 0.01
  },
  {
    "id": 31,
    "system": "achievement-assistant",
    "name": "scholarSearch",
    "label": "专家查询",
    "path": "/api/questions/create-question-scholar",
    "quota": 1,
    "order": 6,
    "price": 0.01
  },
  {
    "id": 32,
    "system": "achievement-assistant",
    "name": "technicalQA",
    "label": "技术问答",
    "path": "/api/questions/create-question-generate",
    "quota": 1,
    "order": 7,
    "price": 0.01
  }
];

/**
 * 获取缓存的配额数据
 */
function getCachedQuotaData() {
  const now = Date.now();

  // 缓存有效期内直接返回缓存
  if (quotaCache && (now - cacheTimestamp) < CACHE_DURATION) {
    return quotaCache;
  }

  try {
    const rawQuota = localStorage.getItem('at_quota');

    // 如果 localStorage 有数据，解析并缓存
    if (rawQuota) {
      const parsedData = JSON.parse(rawQuota);

      // 验证数据结构
      if (!Array.isArray(parsedData)) {
        console.warn('配额数据格式不正确，应为数组');
        quotaCache = DEFAULT_QUOTA_LIST;
      } else {
        quotaCache = parsedData;
      }
    } else {
      // localStorage 没有数据时，直接使用默认数据
      quotaCache = DEFAULT_QUOTA_LIST;
    }

    cacheTimestamp = now;
    return quotaCache;
  } catch (error) {
    console.error('配额数据解析失败');
    // 解析失败时使用默认数据
    quotaCache = DEFAULT_QUOTA_LIST;
    cacheTimestamp = now;
    return quotaCache;
  }
}

/**
 * 获取指定标签的配额对象
 * @param {string} tagLabel - 标签名称
 * @returns {Object|null} 配额对象，未找到时返回null
 */
export function getQuotaObj(tagLabel) {
  if (!tagLabel || typeof tagLabel !== 'string') {
    console.warn('label参数必须是非空字符串');
    return null;
  }

  const tags = getCachedQuotaData();

  const targetTagQuota = tags.find(item => item.label === tagLabel);

  if (!targetTagQuota) {
    console.warn(`未配置"${tagLabel}"访问权限`);
    return null;
  }

  return { ...targetTagQuota }; // 返回浅拷贝
}
